import { render, staticRenderFns } from "./AutoRefresh.vue?vue&type=template&id=249bfa2f&scoped=true&"
import script from "./AutoRefresh.vue?vue&type=script&lang=js&"
export * from "./AutoRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249bfa2f",
  null
  
)

export default component.exports